export default __webpack_public_path__ + "static/media/heat-map.635ead62.png";